import * as z from 'zod'

import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {FormSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/form'
import {PrimerComponentCardSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'
import {PrimerComponentProseSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentProse'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {GenericCallToActionSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/genericCallToAction'
import {IndexFilterSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/indexTemplate'
import {PrimerComponentFaqGroupSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {PersonSchema} from './person'

export const TemplateResourceDetailsSchema = buildEntrySchemaFor('templateResourceDetails', {
  fields: z.lazy(() =>
    z.object({
      resourceType: z.union([z.literal('Article'), z.literal('Insight'), z.literal('Research')]).optional(),
      hero: safeOptional(PrimerComponentHeroSchema),
      publishedDate: z.string().optional(), // Contentful Date, string formatted as "YYYY-MM-DD"
      eventPageType: z.union([z.literal('event'), z.literal('on-demand'), z.literal('listing')]).optional(),
      eventAttendanceMode: z.union([z.literal('in-person'), z.literal('online'), z.literal('hybrid')]).optional(),
      startDate: z.string().optional(),
      endDate: z.string().optional(),
      locationName: z.string().optional(),
      locationStreetAddress: z.string().optional(),
      locationAddressLocality: z.string().optional(),
      locationAddressRegion: z.string().optional(),
      locationPostalCode: z.string().optional(),
      locationAddressCountry: z.string().optional(),
      virtualLocationUrl: z.string().optional(),
      featuredImage: safeOptional(AssetSchema),
      lede: safeOptional(RichTextSchema),
      body: safeOptional(PrimerComponentProseSchema),
      tableOfContents: z.boolean().optional(),
      featuredCta: safeOptional(GenericCallToActionSchema),
      form: safeOptional(FormSchema),
      peopleLabel: z.string().optional(),
      people: safeOptional(z.array(PersonSchema)),
      tags: safeOptional(z.array(IndexFilterSchema)),
      tagsLabel: z.string().optional(),
      relatedResources: safeOptional(z.array(PrimerComponentCardSchema)),
      faq: safeOptional(PrimerComponentFaqGroupSchema),
    }),
  ),
})

export type ResourceDetailsPage = z.infer<typeof TemplateResourceDetailsSchema>
